import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { useAdminAuth } from '@/hooks/useAdminAuth';

export function LoginPage() {
  const { login, loginWithToken, isLoading, error, isAdmin } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState('');
  const [mode, setMode] = useState<'credentials' | 'token'>('credentials');

  // If already logged in, redirect
  if (isAdmin) {
    navigate('/dashboard', { replace: true });
    return null;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (mode === 'token') {
      await loginWithToken(token);
    } else {
      await login(email, password);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-brand-primary/10 rounded-2xl flex items-center justify-center">
              <Shield className="w-8 h-8 text-brand-primary" />
            </div>
          </div>
          <CardTitle className="text-2xl">Sentinel 管理後台</CardTitle>
          <CardDescription>登入以存取管理後台</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {mode === 'credentials' ? (
              <>
                <div className="space-y-2">
                  <label className="text-sm font-medium">電子郵件</label>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="admin@sentinel-bot.com"
                    required
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-medium">密碼</label>
                  <Input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="輸入密碼"
                    required
                  />
                </div>
              </>
            ) : (
              <div className="space-y-2">
                <label className="text-sm font-medium">JWT Token</label>
                <Input
                  value={token}
                  onChange={(e) => setToken(e.target.value)}
                  placeholder="貼上您的 JWT 存取權杖"
                  required
                />
              </div>
            )}

            {error && (
              <div className="text-sm text-destructive bg-destructive/10 p-3 rounded-lg">{error}</div>
            )}

            <Button type="submit" className="w-full" disabled={isLoading}>
              {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              登入
            </Button>

            <button
              type="button"
              onClick={() => setMode(mode === 'credentials' ? 'token' : 'credentials')}
              className="w-full text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              {mode === 'credentials' ? '改用 JWT Token 登入' : '改用帳號密碼登入'}
            </button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
